.entityCard {
  margin-top: 16px;
}
